module.exports = __webpack_public_path__ + "img/palestine.3c893b30.svg";